export default __webpack_public_path__ + "static/media/sv_3.859d9e5a.webp";